
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live/our-app",
      function () {
        return require("private-next-pages/live/our-app.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live/our-app"])
      });
    }
  